import { QwGuestType } from '../../index';
import { BasketModel, OfferCode, SessionHelper, SessionModel } from '@cesare';

export function isAccommodationSatisfied(
  basketRooms: BasketModel['rooms'],
  options?: { session?: SessionModel; numberOfGuests?: number }
) {
  const basketRoomsOccupancies = getBasketRoomOccupancy(basketRooms);

  const totalBasketAdults = getTotalNumberOfGuest(
    basketRoomsOccupancies,
    QwGuestType.Adults
  );
  const totalBasketChildren = getTotalNumberOfGuest(
    basketRoomsOccupancies,
    QwGuestType.Children
  );
  const totalBasketInfants = getTotalNumberOfGuest(
    basketRoomsOccupancies,
    QwGuestType.Infants
  );

  if (options.session) {
    const totalSessionGuests = SessionHelper.getTotalGuests(options.session);
    return (
      totalSessionGuests <=
      totalBasketAdults + totalBasketChildren + totalBasketInfants
    );
  }
  if (options.numberOfGuests) {
    return (
      options.numberOfGuests <=
      totalBasketAdults + totalBasketChildren + totalBasketInfants
    );
  }
}

export function getBasketRoomOccupancy(basketRooms: BasketModel['rooms']) {
  return basketRooms.map((room) => {
    const roomOccupancies = Object.values(room.occupancies).map((o: any) => {
      return {
        qty: o.selectedQuantity,
        value: o.definition.value,
        id: o.occupancyId,
      };
    });
    const roomOccupancyDefinitionPerRoomQty = roomOccupancies.reduce(
      (acc, o: any) => {
        return {
          ...acc,
          [o.id]: o.value.isDetailed
            ? {
                adultCount: o.value.adultCount * o.qty,
                childCount: o.value.childCount * o.qty,
                infantCount: o.value.infantCount * o.qty,
              }
            : {
                personCount: o.value.personCount * o.qty,
              },
        };
      },
      {}
    );
    return roomOccupancyDefinitionPerRoomQty;
  });
}

export function getTotalNumberOfGuest(basketRoomsOccupancies, guestType) {
  return basketRoomsOccupancies?.reduce((acc, occupancy) => {
    const guests = Object.values(occupancy).reduce((acc, o: any) => {
      if (guestType === QwGuestType.Adults) {
        return o.personCount ? acc + o.personCount : acc + o.adultCount;
      } else if (guestType === QwGuestType.Children) {
        return o.childCount ? acc + o.childCount : acc;
      } else if (guestType === QwGuestType.Infants) {
        return o.infantCount ? acc + o.infantCount : acc;
      }
    }, 0);
    return acc + guests;
  }, 0);
}

export function hasBasketNotificationWarning(
  promoCode: SessionModel['context']['promoCode'],
  numberOfRooms: number,
  offerCode: OfferCode
): boolean {
  return promoCode && numberOfRooms > 0 && !offerCode;
}
